const o = {
  name: "Download",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 13.5857L13 3H11L11 13.5859L7.99991 10.5858L6.58569 12L11.9999 17.4142L17.4141 12L15.9999 10.5858L13 13.5857Z" fill="currentColor"/>
<path d="M4 15V18C4 18.5523 4.44772 19 5 19H19C19.5523 19 20 18.5523 20 18V15H22V18C22 19.6569 20.6569 21 19 21H5C3.34315 21 2 19.6569 2 18V15H4Z" fill="currentColor"/>
</svg>
  `
};
export {
  o as Download
};
